/**
 * Engine-tuning helpers derived from wavesNum.
 * Extracted from field-config-adapter.ts so that field-yaml-loader.ts
 * can reuse the same defaults without duplication.
 */

export function monstersPerWaveForWaves(waves: number): number {
  // Starter fields (≤10 waves) get fewer mobs so 2–3 towers have a chance.
  if (waves <= 10) return 5;
  if (waves <= 14) return 9;
  if (waves <= 20) return 12;
  if (waves <= 35) return 14;
  return 16;
}

export function spawnIntervalMsForWaves(waves: number): number {
  // Starter fields get a wider spawn gap so single-tower setups can thin hordes.
  if (waves <= 10) return 1200;
  if (waves <= 14) return 900;
  if (waves <= 20) return 750;
  if (waves <= 35) return 650;
  return 550;
}
